var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Modal",
    {
      attrs: { confirmMessage: "Save", confirmEnabled: !_vm.loading },
      on: {
        confirm: _vm.save,
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
      scopedSlots: _vm._u([
        {
          key: "title",
          fn: function () {
            return [
              _vm._v("Sharing options for corpus "),
              _c("em", [_vm._v(_vm._s(_vm.corpus.displayName))]),
            ]
          },
          proxy: true,
        },
        {
          key: "header",
          fn: function () {
            return [
              _c("small", { staticClass: "text-muted" }, [
                _vm._v("One username per line"),
              ]),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm._v(" "),
      _c("textarea", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.content,
            expression: "content",
          },
        ],
        staticClass: "form-control",
        staticStyle: { width: "100%", height: "400px", resize: "vertical" },
        domProps: { value: _vm.content },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.content = $event.target.value
          },
        },
      }),
      _vm._v(" "),
      _vm.error
        ? _c("div", { staticClass: "alert alert-danger" }, [
            _c(
              "a",
              {
                staticClass: "close",
                attrs: { href: "#", "aria-label": "close" },
                on: {
                  click: function ($event) {
                    _vm.error = ""
                  },
                },
              },
              [_vm._v("×")]
            ),
            _vm._v("\n\t\t" + _vm._s(_vm.error) + "\n\t"),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }